/**
 * VAVELE — Product Detail Page JS
 *
 * Sections:
 *   1. Engraving — uppercase enforcement + character counter
 *   2. Sticky ATC — Model B2 size confirmation gate (mobile only)
 *
 * Safe to load deferred. Does not conflict with:
 *   product-info.js, product-form.js, media-gallery.js, variant-selects.js
 *
 * Loaded from: sections/main-product.liquid (additive line, see implementation notes).
 */

(function () {
  'use strict';

  /**
   * Init all engraving inputs on the page.
   * Runs once on DOMContentLoaded.
   * Safe to call multiple times — uses a guard flag.
   */
  function initVaveleEngraving() {
    var inputs = document.querySelectorAll('[data-vavele-engraving-input]');
    if (!inputs.length) return;

    inputs.forEach(function (input) {
      var fieldRow = input.closest('.vavele-engraving__field-row');
      var counterEl = fieldRow
        ? fieldRow.querySelector('[data-vavele-counter-current]')
        : null;

      /**
       * On every keystroke:
       * 1. Convert value to uppercase — this changes the SUBMITTED value,
       *    not just the visual display. CSS text-transform alone does not
       *    change submitted form data.
       * 2. Restore caret position after .value assignment (desktop safety).
       * 3. Update the character counter.
       */
      input.addEventListener('input', function () {
        var caretStart = this.selectionStart;
        var caretEnd = this.selectionEnd;
        var upper = this.value.toUpperCase();

        if (this.value !== upper) {
          this.value = upper;
          // Restore caret after value assignment resets it to end.
          try {
            this.setSelectionRange(caretStart, caretEnd);
          } catch (_) {
            // setSelectionRange not supported on all input types — silent fail.
          }
        }

        if (counterEl) {
          counterEl.textContent = this.value.length;
        }
      });

      /**
       * On paste: same enforcement.
       * Browsers fire 'input' after paste on most platforms, but
       * this explicit handler catches edge cases (e.g. iOS Safari paste menu).
       */
      input.addEventListener('paste', function () {
        // Defer by one tick so pasted value is committed to .value first.
        var self = this;
        setTimeout(function () {
          var upper = self.value.toUpperCase();
          if (self.value !== upper) {
            self.value = upper;
          }
          if (counterEl) {
            counterEl.textContent = self.value.length;
          }
        }, 0);
      });
    });
  }

  // Run after DOM is ready. Works whether script is deferred or inline.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVaveleEngraving);
  } else {
    initVaveleEngraving();
  }

})();

/* ============================================================
   VAVELE — MOBILE STICKY ADD TO CART v5
   Full replacement of v4. Systemic rewrite on verified signals.

   WHY v5 EXISTS (read before editing):
   v4 (and the still-live legacy asset) ran a cart-state machine —
   ZOBACZ KOSZYK, cart-count parsing, cart-drawer childList/subtree
   observers, awaitingDrawer valves. That machine produced Bugs A and C
   and could not be debounced into stability. v5 deletes it entirely.

   VERIFIED SIGNALS (DevTools probe, 2026-05-30):
   - Drawer open  → document.body has class "mini-cart-open".
                    cart-drawer has NO [open], no useful class, aria-hidden null.
                    So we trust ONLY body.mini-cart-open — no :has(), no
                    [open]/.active/.is-open/aria-hidden guessing.
   - Native btn   → #ProductSubmitButton-<section.id>, inside .product-form__buttons.
                    nativeBtn.click() is the submit path. No /cart/add.js.
   - Single sticky, no native sticky_cart block present.

   STATE (only what is needed):
     isMultiSize, sizeConfirmed, submitting, drawerOpen, keyboardActive
   FORBIDDEN (deleted on purpose):
     itemAddedFromSticky, cartHasItems, zobaczKoszyk, cart retention,
     cart-count parsing, cart-drawer content observers, awaitingDrawer.

   RENDER PRIORITY (single source of truth):
     1. Desktop >=750px            → hidden
     2. Drawer open (body class)   → hidden  (drawer owns the screen)
     3. Submitting                 → hidden  (set synchronously on add-click)
     4. Engraving keyboard active  → hidden
     5. Multi-size, !confirmed     → "WYBIERZ ROZMIAR"  (gate)
     6. Default                    → "DODAJ DO KOSZYKA — [price]"

   Rollback: git checkout assets/vavele-pdp.js
   Modified: 2026-05-30
   ============================================================ */
(function () {
  'use strict';

  /* ── DOM ─────────────────────────────────────────────────── */

  var stickyBar = document.getElementById('vavele-sticky-atc');
  if (!stickyBar) return;

  var mq = window.matchMedia('(min-width: 750px)');
  if (mq.matches) return; /* Desktop: CSS handles hide, no JS overhead */

  var nativeBtn        = document.getElementById(stickyBar.dataset.nativeBtnId)
                         || document.querySelector('product-form [name="add"]')
                         || document.querySelector('product-form button[type="submit"]')
                         || document.querySelector('button[name="add"]');
  var stickyBtn        = stickyBar.querySelector('.vavele-sticky-atc__btn');
  var stickyText       = stickyBar.querySelector('.vavele-sticky-atc__text');
  var engInputEl       = document.querySelector('[data-vavele-engraving-input]');
  var variantSelectsEl = document.querySelector('variant-selects[data-primary]');

  function getVariantRoot() {
  return document.querySelector('variant-selects[data-primary]');
}

function getSizeFieldset(root) {
  root = root || getVariantRoot();
  if (!root) return null;

  var fieldsets = root.querySelectorAll('fieldset, .product-form__input');

  for (var i = 0; i < fieldsets.length; i++) {
    var fieldset = fieldsets[i];

    var legend = fieldset.querySelector('legend');
    var legendText = legend ? legend.textContent.trim().toLowerCase() : '';

    if (
      legendText.indexOf('size') !== -1 ||
      legendText.indexOf('rozmiar') !== -1 ||
      legendText.indexOf('ring size') !== -1
    ) {
      return fieldset;
    }

    var input = fieldset.querySelector('input.button-input__input, input[type="radio"]');
    var inputName = input && input.name ? input.name.toLowerCase() : '';

    if (
      inputName.indexOf('size') !== -1 ||
      inputName.indexOf('rozmiar') !== -1 ||
      inputName.indexOf('ring') !== -1
    ) {
      return fieldset;
    }
  }

  return null;
}

  if (!nativeBtn || !stickyBtn || !stickyText) return;

  /* Drawer-open signal: Be Yours toggles cart-drawer lifecycle classes on <body>
     — mini-cart--opening / mini-cart--open / mini-cart--closing. All three are a
     hard-suppress state. 'mini-cart-open' (single dash) kept only as a harmless
     backward-compatible fallback. See isDrawerOpen(). */

  /* ── STATE ───────────────────────────────────────────────── */

  var S = {
    isMultiSize:    false,
    sizeConfirmed:  false,
    submitting:     false,  /* true from add-click until drawer opens or recovery fires */
    drawerOpen:     false,  /* mirrors isDrawerOpen() — body cart-drawer lifecycle classes */
    keyboardActive: false   /* true only while engraving input is focused */
  };

  /* ── INIT — MULTI-SIZE ───────────────────────────────────── */

  S.isMultiSize = !!(
    variantSelectsEl &&
    variantSelectsEl.querySelectorAll(
      '.product-form__input--pill input.button-input__input'
    ).length > 1
  );

  S.sizeConfirmed = !S.isMultiSize;
  S.drawerOpen    = isDrawerOpen();

  if (S.isMultiSize && variantSelectsEl) {
    document.documentElement.classList.add('vavele-size-unconfirmed'); /* html-scoped for sibling-combinator CSS */
    variantSelectsEl.classList.add('vavele-size-unconfirmed');
    markDefaultPillNeutral();
  }

  /* ── SIZE PILL NEUTRALIZATION (preserved — was working) ──────
     Tags the label wrapping the default checked input with
     data-vavele-neutral. CSS targets the attribute directly — no
     ~ sibling traversal, works regardless of Be Yours nesting depth.
     Cleared on first explicit size tap.
  ─────────────────────────────────────────────────────────── */
function markDefaultPillNeutral() {
    var root = document.querySelector('variant-selects[data-primary]');
    if (!root) return;

    var sizeFieldset = null;
    root.querySelectorAll('fieldset, .product-form__input').forEach(function (fieldset) {
      if (sizeFieldset) return;

      var legend = fieldset.querySelector('legend');
      var legendText = legend ? legend.textContent.trim().toLowerCase() : '';

      var input = fieldset.querySelector('input.button-input__input');
      var inputName = input && input.name ? input.name.toLowerCase() : '';

      if (
        legendText.indexOf('rozmiar') !== -1 ||
        legendText.indexOf('size') !== -1 ||
        inputName.indexOf('rozmiar') !== -1 ||
        inputName.indexOf('size') !== -1
      ) {
        sizeFieldset = fieldset;
      }
    });

    if (!sizeFieldset) return;

    sizeFieldset.setAttribute('data-vavele-size-fieldset', 'true');

    var checked = sizeFieldset.querySelector('input.button-input__input:checked');
    if (!checked) return;

    var label = checked.nextElementSibling;

    if (!label || label.tagName !== 'LABEL') {
      label = root.querySelector('label[for="' + checked.id + '"]');
    }

    if (label) {
      label.setAttribute('data-vavele-neutral', 'true');
    }
  }

    /* ── SIZE OPTION DETECTION ─────────────────────────────────
     Critical: color and size can both be rendered as .product-form__input--pill.
     confirmSize() must run ONLY when the user taps the size option group,
     never when the user changes color/material.
  ─────────────────────────────────────────────────────────── */
  function isSizePickerTarget(target) {
  if (!target) return false;

  var fieldset = target.closest('fieldset, .product-form__input');
  if (!fieldset) return false;

  var legend = fieldset.querySelector('legend');
  var legendText = legend ? legend.textContent.trim().toLowerCase() : '';

  if (
    legendText.indexOf('size') !== -1 ||
    legendText.indexOf('rozmiar') !== -1 ||
    legendText.indexOf('ring size') !== -1
  ) {
    return true;
  }

  var input = target.matches && target.matches('input')
    ? target
    : target.querySelector && target.querySelector('input');

  if (!input) {
    input = fieldset.querySelector('input.button-input__input');
  }

  var inputName = input && input.name ? input.name.toLowerCase() : '';

  if (
    inputName.indexOf('size') !== -1 ||
    inputName.indexOf('rozmiar') !== -1 ||
    inputName.indexOf('ring') !== -1
  ) {
    return true;
  }

  return false;
}

 function keepSizeUnconfirmed() {
  if (!S.isMultiSize || S.sizeConfirmed) return;

  document.documentElement.classList.add('vavele-size-unconfirmed');

  var root = getVariantRoot();
  if (root) {
    root.classList.add('vavele-size-unconfirmed');
  }

  markDefaultPillNeutral();
}

function clearNeutralPills() {
  var root = getVariantRoot();
  if (!root) return;

  root.querySelectorAll('[data-vavele-neutral]').forEach(function (el) {
    el.removeAttribute('data-vavele-neutral');
  });
}

function setExplicitActiveSizeLabel() {
  var root = getVariantRoot();
  if (!root) return;

  var sizeFieldset = getSizeFieldset(root);
  if (!sizeFieldset) return;

  sizeFieldset.setAttribute('data-vavele-size-fieldset', 'true');

  sizeFieldset.querySelectorAll('[data-vavele-explicit-active]').forEach(function (el) {
    el.removeAttribute('data-vavele-explicit-active');
  });

  var checked = sizeFieldset.querySelector('input.button-input__input:checked');
  if (!checked) return;

  var label = checked.nextElementSibling;

  if (!label || label.tagName !== 'LABEL') {
    label = root.querySelector('label[for="' + checked.id + '"]');
  }

  if (label) {
    label.setAttribute('data-vavele-explicit-active', 'true');
  }
}

function confirmSize() {
  S.sizeConfirmed = true;

  clearNeutralPills();
  document.documentElement.classList.remove('vavele-size-unconfirmed');

  var root = getVariantRoot();
  if (root) {
    root.classList.remove('vavele-size-unconfirmed');
  }

  setExplicitActiveSizeLabel();
}

  /* ── PRICE (preserved) ───────────────────────────────────── */

  function getSelectedVariant() {
    var root = variantSelectsEl || document.querySelector('variant-selects[data-primary]');
    var el = root ? root.querySelector('[data-selected-variant]') : null;
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (_) { return null; }
  }

  function formatPrice(cents) {
    if (
      typeof theme !== 'undefined' &&
      theme.Currency &&
      theme.shopSettings &&
      theme.shopSettings.moneyFormat
    ) {
      return theme.Currency.formatMoney(cents, theme.shopSettings.moneyFormat);
    }
    return '';
  }

  function readPriceFromDOM() {
    var c = document.querySelector('.price__container');
    if (!c) {
      var fb = document.querySelector('.price__regular .price-item--regular')
            || document.querySelector('.price-item--regular')
            || document.querySelector('[data-product-price]');
      return fb ? fb.textContent.trim() : '';
    }
    var onSale = !!c.closest('.price--on-sale');
    var el = onSale
      ? c.querySelector('.price-item--sale')
      : c.querySelector('.price-item--regular');
    if (!el) el = c.querySelector('.price-item--regular, .price-item--sale');
    return el ? el.textContent.trim() : '';
  }

  function getDisplayPrice(variant) {
    if (variant && variant.price != null) {
      var f = formatPrice(variant.price);
      if (f) return f;
    }
    return readPriceFromDOM();
  }

  /* ── DRAWER (lifecycle classes — hard suppression) ───────── */
  /*
    Be Yours drives the cart drawer through three <body> BEM modifier classes:
      mini-cart--opening  → drawer sliding in
      mini-cart--open     → drawer fully open
      mini-cart--closing  → drawer sliding out
    ALL THREE must suppress the sticky (opening/open/closing = hard suppress).
    Checking only one — or the wrong single-dash variant — was the root cause of
    the bar reappearing over the open drawer at the 3s recovery tick.
    'mini-cart-open' retained as a zero-cost fallback for older builds.
  */
  function isDrawerOpen() {
    var c = document.body.classList;
    return c.contains('mini-cart--opening')
        || c.contains('mini-cart--open')
        || c.contains('mini-cart--closing')
        || c.contains('mini-cart-open');
  }

  /* ── SHOW / HIDE ─────────────────────────────────────────── */

  function showSticky() {
    stickyBtn.disabled = false;            /* any prior submit lock is cleared on show */
    stickyBar.classList.add('vavele-sticky-atc--visible');
    stickyBar.setAttribute('aria-hidden', 'false');
  }

  function hideSticky() {
    stickyBar.classList.remove('vavele-sticky-atc--visible');
    stickyBar.setAttribute('aria-hidden', 'true');
  }

  /* ── SCROLL TO PICKER ────────────────────────────────────── */

  function scrollToPicker() {
    var target = document.querySelector(
      'variant-selects[data-primary] .product-form__input--pill'
    ) || variantSelectsEl;
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    target.classList.add('vavele-size-highlight');
    setTimeout(function () { target.classList.remove('vavele-size-highlight'); }, 1300);
  }

  /* ── RENDER — SINGLE SOURCE OF TRUTH ─────────────────────── */
  /*
    Every listener mutates S then calls render(). render() is the only
    function that decides visibility and copy. There are no independent
    show/hide paths. NIEDOSTĘPNY / sold-out suppressed in MVP to avoid
    Be Yours transient disabled flashes.
  */
  function render() {
    /* HARD SUPPRESSION — checked first and LIVE (not cached S.drawerOpen), so
       nothing below, including a stray recovery render, can show the sticky
       over an opening/open/closing drawer. */
    if (mq.matches)       { hideSticky(); return; }  /* 1. desktop */
    if (isDrawerOpen())   { hideSticky(); return; }  /* 2. drawer opening/open/closing (live) */
    if (S.keyboardActive) { hideSticky(); return; }  /* 3. engraving keyboard */
    if (S.submitting)     { hideSticky(); return; }  /* 4. add in flight — never overrides drawer */

    /* 5. gate — multi-size, no explicit confirmation yet */
    if (S.isMultiSize && !S.sizeConfirmed) {
      stickyBtn.dataset.state = 'confirm';
      stickyBtn.setAttribute('aria-label', 'Wybierz rozmiar');
      stickyText.textContent = 'WYBIERZ ROZMIAR';
      showSticky();
      return;
    }

    /* 6. active — add to cart */
    var price = getDisplayPrice(getSelectedVariant());
    stickyBtn.dataset.state = 'add';
    stickyBtn.setAttribute('aria-label', 'Dodaj do koszyka');
    stickyText.textContent = price ? 'DODAJ DO KOSZYKA · ' + price : 'DODAJ DO KOSZYKA';
    showSticky();
  }

  /* ── NATIVE ATC INTERCEPT (multi-size gate, preserved) ───── */
  /*
    If size not yet confirmed, the native (hidden) button must not submit —
    it scrolls to the picker instead. When the sticky fires nativeBtn.click()
    in 'add' state, sizeConfirmed is already true, so this passes through.
  */
  if (S.isMultiSize) {
    nativeBtn.addEventListener('click', function (e) {
      if (S.sizeConfirmed) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      scrollToPicker();
    }, true);
  }

  /* ── SIZE PILL CLICK (preserved) ─────────────────────────── */
  /*
    'click' not 'change': re-tapping the already-checked default radio does
    not fire 'change' but does fire 'click' — this is how re-tapping the
    preselected size counts as explicit confirmation.
  */
    document.addEventListener('click', function (e) {
  var pillGroup = e.target.closest('variant-selects[data-primary] .product-form__input--pill');
  if (!pillGroup) return;

  if (isSizePickerTarget(pillGroup)) {
    confirmSize();
    render();
    return;
  }

  /* Color/material pill clicked before size selection:
     keep size gate active and do not visually confirm default size. */
  keepSizeUnconfirmed();
  render();
});

  /* ── VARIANT CHANGE ──────────────────────────────────────── */
  /*
    Keyboard navigation of size pills fires 'change'. Confirm size, then
    schedule one render so Be Yours' async price/variant JSON can settle.
    This is the ONLY debounce in v5 and it exists solely for price refresh —
    it does not gate the happy path.
  */
  var priceSettleTimer = null;
    document.addEventListener('change', function (e) {
  if (!e.target.closest('variant-selects[data-primary]')) return;

  if (e.target.classList.contains('button-input__input')) {
    if (isSizePickerTarget(e.target)) {
      confirmSize();
    } else {
      keepSizeUnconfirmed();
    }
  }

  /* Immediate render for state change. Price may refresh again after Be Yours settles. */
  render();

  clearTimeout(priceSettleTimer);
  priceSettleTimer = setTimeout(render, 150);
});

  /* ── VARIANT SELECTS RE-RENDER (neutralization only) ─────── */
  /*
    Be Yours may replace variant-selects inner HTML on async section fetch.
    Re-apply neutralization ONLY while size is unconfirmed, then render.
    Note: this observes variant-selects (NOT the cart drawer). The v5 ban on
    childList/subtree observers applies specifically to the cart drawer.
  */
 var mutationRenderTimer = null;

new MutationObserver(function (mutations) {
  var variantChanged = false;

  mutations.forEach(function (mutation) {
    if (
      mutation.target &&
      mutation.target.closest &&
      mutation.target.closest('variant-selects[data-primary]')
    ) {
      variantChanged = true;
    }

    mutation.addedNodes.forEach(function (node) {
      if (node.nodeType !== 1) return;

      if (
        node.matches && node.matches('variant-selects[data-primary]') ||
        node.querySelector && node.querySelector('variant-selects[data-primary]')
      ) {
        variantChanged = true;
      }
    });
  });

  if (!variantChanged) return;

if (!S.sizeConfirmed) {
  keepSizeUnconfirmed();
} else {
  setExplicitActiveSizeLabel();
}

  clearTimeout(mutationRenderTimer);
  mutationRenderTimer = setTimeout(function () {
    if (!S.sizeConfirmed) {
  keepSizeUnconfirmed();
} else {
  setExplicitActiveSizeLabel();
}
    render();
  }, 50);
}).observe(document.querySelector('#MainContent') || document.body, {
  childList: true,
  subtree: true
});

  /* ── DRAWER OPEN/CLOSE (single attributes-only observer) ─── */
  /*
    The only drawer observer in v5. Watches body.class for the cart-drawer
    lifecycle classes (see isDrawerOpen()). Handles EVERY drawer interaction —
    add-to-cart success, header cart icon, item removal — with one stable signal.
    No content/childList observation.
  */
  new MutationObserver(function () {
    var open = isDrawerOpen();
    if (open === S.drawerOpen) return;
    S.drawerOpen = open;
    if (open) {
      /* Drawer opened → add succeeded (or user opened cart). Drop submit lock. */
      S.submitting = false;
      clearTimeout(submitFailTimer);
    }
    render();
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  /* ── STICKY BUTTON CLICK ─────────────────────────────────── */

  var submitFailTimer = null;

  stickyBtn.addEventListener('click', function () {
    var state = stickyBtn.dataset.state;

    if (state === 'confirm') {
      scrollToPicker();
      return;
    }

    if (state === 'add') {
      if (S.submitting) return;
      if (nativeBtn.disabled || nativeBtn.getAttribute('aria-disabled') === 'true') return;

      /* Decision 5: hide immediately, before nativeBtn.click(), no delay.
         The drawer owns the purchase moment from here. */
      S.submitting = true;
      stickyBtn.disabled = true;
      hideSticky();

      /* Blur guard: if the engraving input is focused when Add to Cart is
         tapped, blur it and wait 320 ms before submitting. This lets iOS
         Safari fully stabilize the viewport after keyboard dismiss before
         Be Yours applies its drawer scroll-lock — preventing the slide-left
         + drop glitch on iPhone 15 Safari. On the normal path (no engraving
         input focused), nativeBtn.click() fires synchronously as before. */
      clearTimeout(submitFailTimer); /* cancel any stale recovery timer first */

   var doNativeClick = function () {
  /* rAF + 50ms:
     Let the browser remove/reflow the fixed Sticky ATC before Be Yours
     applies cart drawer scroll-lock and transform. This keeps the native
     product-form path intact, so properties[Grawerunek] remain safe. */
  requestAnimationFrame(function () {
    setTimeout(function () {
      nativeBtn.click();

      /* Failure recovery ONLY: if the drawer never opens, restore sticky.
         Guarded by isDrawerOpen(), so it cannot reappear over the drawer. */
      submitFailTimer = setTimeout(function () {
        if (!isDrawerOpen()) {
          S.submitting = false;
          render();
        }
      }, 3000);
    }, 50);
  });
};

      if (engInputEl && document.activeElement === engInputEl) {
        engInputEl.blur();
        setTimeout(doNativeClick, 320);
      } else {
        doNativeClick();
      }
    }
  });

  /* ── ENGRAVING KEYBOARD SUPPRESSION ──────────────────────── */
  /*
    Stable MVP model — minimal surface area:
    - focusin  → S.keyboardActive = true  → hide sticky immediately.
    - focusout → S.keyboardActive = false → render() after 300 ms delay.

    The 300 ms delay lets the iOS keyboard dismiss animation complete
    before the sticky slides in (avoids partial-cut visual artefact).

    REMOVED (was causing instability):
    - visualViewport listener: not needed for MVP; caused iOS toolbar-
      collapse to trigger false render() calls. No sticky repositioning
      via transform/bottom was happening, but the listener added noise.
    - pointerdown/touchstart intent flag: Be Yours <details>/<summary>
      does not auto-focus the first input, so the guard was unnecessary
      complexity. Plain focusin is sufficient and stable.
    - Gotowe click handler: button is CSS-hidden for MVP.

    Accordion open does NOT hide sticky: <details> toggle does not fire
    focusin on the engraving input.
    Drawer suppression still runs first in render() — drawer always wins.
  */
  if (engInputEl) {
    var engBlurTimer = null;

    engInputEl.addEventListener('focusin', function () {
      clearTimeout(engBlurTimer);
      S.keyboardActive = true;
      stickyBar.classList.add('vavele-sticky-atc--keyboard');
      hideSticky();
    });

    engInputEl.addEventListener('focusout', function () {
      S.keyboardActive = false;
      stickyBar.classList.remove('vavele-sticky-atc--keyboard');
      engBlurTimer = setTimeout(render, 300);
    });
  }

  /* ── MEDIA QUERY ─────────────────────────────────────────── */

  mq.addEventListener('change', function () { render(); });

  /* ── INITIAL ─────────────────────────────────────────────── */

  render();

})();

/* ============================================================
   VAVELE — IN-FLOW ATC CONTROLLER v3
   Stage 1: mobile purchase flow CTA inside the product form.

   Replaces v2 (IIFE #3 — broken). Adapts proven sticky v5 size-gate logic.

   ROOT CAUSE FIX vs v2:
   v2 delegation and getGateFieldset both used .product-form__input (base
   class), which is emitted on BOTH top-level option group containers AND
   nested wrappers inside product-variant-options.liquid. When e.target
   .closest('.product-form__input') resolved to a nested wrapper, indexOf()
   returned the wrong position and the guard fired return — onGateInteraction
   never called, state stuck at 'confirm' indefinitely.

   v3 fix: TOP_OPTION_GROUP uses modifier classes only
   (.product-form__input--pill / --swatch / --dropdown) which are emitted
   ONLY on top-level option group containers — exactly what sticky v5 does
   via .product-form__input--pill in its click delegation.

   Removed vs v2 (solving a DOM-replacement problem sameCta:true disproved):
     confirmedMap, activeSectionHandlers, boundVariantRoots, productInfoEl
     MutationObserver. Per-instance closure is stable and sufficient.

   Do not edit IIFE #1 (engraving) or IIFE #2 (sticky v5).
   Rollback: git checkout assets/vavele-pdp.js
   Modified: 2026-06-05
   ============================================================ */
(function () {
  'use strict';

  /* Top-level option group selector — modifier classes ONLY.
     .product-form__input (base) also appears on nested wrappers inside
     product-variant-options.liquid. Modifier classes are emitted only on
     the top-level fieldset/div for each option — same signal sticky v5 uses. */
  var TOP_OPTION_GROUP = '.product-form__input--pill, .product-form__input--swatch, .product-form__input--dropdown';

  /* ── HELPERS ──────────────────────────────────────────────── */

  function isDrawerOpen() {
    var c = document.body.classList;
    return c.contains('mini-cart--opening')
        || c.contains('mini-cart--open')
        || c.contains('mini-cart--closing')
        || c.contains('mini-cart-open');
  }

  function getSelectedVariant(variantRoot) {
    if (!variantRoot) return null;
    var el = variantRoot.querySelector('[data-selected-variant]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (_) { return null; }
  }

  function formatPrice(cents) {
    if (
      typeof theme !== 'undefined' &&
      theme.Currency &&
      theme.shopSettings &&
      theme.shopSettings.moneyFormat
    ) {
      return theme.Currency.formatMoney(cents, theme.shopSettings.moneyFormat);
    }
    return '';
  }

  function readPriceFromDOM() {
    var c = document.querySelector('.price__container');
    if (!c) {
      var fb = document.querySelector('.price__regular .price-item--regular')
            || document.querySelector('.price-item--regular')
            || document.querySelector('[data-product-price]');
      return fb ? fb.textContent.trim() : '';
    }
    var onSale = !!c.closest('.price--on-sale');
    var el = onSale
      ? c.querySelector('.price-item--sale')
      : c.querySelector('.price-item--regular');
    if (!el) el = c.querySelector('.price-item--regular, .price-item--sale');
    return el ? el.textContent.trim() : '';
  }

  function getDisplayPrice(variantRoot) {
    var variant = getSelectedVariant(variantRoot);
    if (variant && variant.price != null) {
      var f = formatPrice(variant.price);
      if (f) return f;
    }
    return readPriceFromDOM();
  }

  /* ── IS GATE PICKER TARGET ────────────────────────────────── */
  /* Ported from sticky v5 isSizePickerTarget. Extended for 'length'.
     Receives a TOP-LEVEL option group element (resolved via TOP_OPTION_GROUP). */

  function isGatePickerTarget(gateType, optionGroupEl) {
    if (!optionGroupEl || gateType === 'none') return false;

    var legend = optionGroupEl.querySelector('legend');
    var legendText = legend ? legend.textContent.trim().toLowerCase() : '';

    var input = optionGroupEl.querySelector('input.button-input__input, input[type="radio"]');
    var inputName = input && input.name ? input.name.toLowerCase() : '';

    if (gateType === 'size') {
      return (
        legendText.indexOf('size') !== -1 ||
        legendText.indexOf('rozmiar') !== -1 ||
        legendText.indexOf('ring size') !== -1 ||
        inputName.indexOf('size') !== -1 ||
        inputName.indexOf('rozmiar') !== -1 ||
        inputName.indexOf('ring') !== -1
      );
    }

    if (gateType === 'length') {
      return (
        legendText.indexOf('length') !== -1 ||
        legendText.indexOf('długość') !== -1 ||
        legendText.indexOf('dlugosc') !== -1 ||
        legendText.indexOf('rozmiar') !== -1 ||
        inputName.indexOf('length') !== -1 ||
        inputName.indexOf('dlugosc') !== -1 ||
        inputName.indexOf('rozmiar') !== -1 ||
        inputName.indexOf('size') !== -1
      );
    }

    return false;
  }

  /* ── PER-CTA INSTANCE ─────────────────────────────────────── */

  function initCtaInstance(cta) {

    /* ── Section-scoped DOM discovery ──────────────────────── */
    var form        = cta.closest('form');
    var sectionId   = cta.dataset.sectionId;
    var nativeBtn   = document.getElementById(cta.dataset.nativeBtnId);
    var variantRoot = sectionId
      ? document.getElementById('variant-selects-' + sectionId)
      : null;
    var engInputEl  = form
      ? form.querySelector('[data-vavele-engraving-input]')
      : null;

    if (!form || !sectionId || !nativeBtn) return;

    var textEl = cta.querySelector('.vavele-inflow-atc__text');
    if (!textEl) return;

    /* CTA data attributes — all labels set from Liquid, never hard-coded here */
    var gateType        = cta.dataset.vaveleGateType          || 'none';
    var gateLabel       = cta.dataset.vaveleGateLabel         || 'WYBIERZ ROZMIAR';
    var addLabel        = cta.dataset.vaveleAddLabel          || 'DODAJ DO KOSZYKA';
    var submittingLabel = cta.dataset.vaveleSubmittingLabel   || 'DODAWANIE…';

    var S = {
      gateConfirmed: gateType === 'none', /* non-gated products are pre-confirmed */
      isSubmitting:  false,
      isUnavailable: false
    };

    var submitFailTimer  = null;
    var priceSettleTimer = null;
    var highlightTimer   = null;
    var lastKnownPrice   = '';   /* last non-empty price — fallback during transient DOM updates */

    /* ── GATE FIELDSET RESOLVER ─────────────────────────────── */
    /* Uses TOP_OPTION_GROUP (modifier classes) so only top-level groups are
       counted — the v2 bug fix. Position-based first (precise); legend text
       fallback second (supports products where position attr is absent). */

    function getGateFieldset() {
      if (!variantRoot || gateType === 'none') return null;

      var gatePos = parseInt(cta.dataset.vaveleGateOptionPosition, 10);

      /* Position-based (preferred) — modifier-class selector is top-level only */
      if (!isNaN(gatePos) && gatePos >= 1) {
        var topGroups = variantRoot.querySelectorAll(TOP_OPTION_GROUP);
        if (topGroups.length >= gatePos) return topGroups[gatePos - 1];
      }

      /* Legend/name text fallback */
      var groups = variantRoot.querySelectorAll(TOP_OPTION_GROUP);
      for (var i = 0; i < groups.length; i++) {
        if (isGatePickerTarget(gateType, groups[i])) return groups[i];
      }

      return null;
    }

    /* ── NEUTRALIZATION (ported faithfully from sticky v5) ───── */
    /*
      markDefaultPillNeutral targets:
        1. checked.nextElementSibling if it is LABEL (Be Yours standard layout)
        2. fallback label[for=checked.id]
      data-vavele-neutral goes directly on the LABEL — CSS keys off the attribute.
      Cleared on first explicit gate tap via clearNeutralState.
    */

    function markDefaultPillNeutral() {
      var gf = getGateFieldset();
      if (!gf || gf.tagName === 'SELECT') return;

      gf.setAttribute('data-vavele-size-fieldset', 'true');

      var checked = gf.querySelector('input.button-input__input:checked')
                 || gf.querySelector('input[type="radio"]:checked');
      if (!checked) return;

      var label = checked.nextElementSibling;
      if (!label || label.tagName !== 'LABEL') {
        label = gf.querySelector('label[for="' + checked.id + '"]')
             || (variantRoot && variantRoot.querySelector('label[for="' + checked.id + '"]'));
      }
      if (label) label.setAttribute('data-vavele-neutral', 'true');
    }

    function applyNeutralState() {
      if (S.gateConfirmed) return;
      document.documentElement.classList.add('vavele-size-unconfirmed');
      if (variantRoot) variantRoot.classList.add('vavele-size-unconfirmed');
      markDefaultPillNeutral();
    }

    function clearNeutralState() {
      document.documentElement.classList.remove('vavele-size-unconfirmed');
      if (variantRoot) {
        variantRoot.classList.remove('vavele-size-unconfirmed');
        variantRoot.querySelectorAll('[data-vavele-neutral]').forEach(function (el) {
          el.removeAttribute('data-vavele-neutral');
        });
      }
    }

    function setExplicitActiveLabel() {
      var gf = getGateFieldset();
      if (!gf || gf.tagName === 'SELECT') return;

      gf.querySelectorAll('[data-vavele-explicit-active]').forEach(function (el) {
        el.removeAttribute('data-vavele-explicit-active');
      });

      var checked = gf.querySelector('input.button-input__input:checked')
                 || gf.querySelector('input[type="radio"]:checked');
      if (!checked) return;

      var label = checked.nextElementSibling;
      if (!label || label.tagName !== 'LABEL') {
        label = gf.querySelector('label[for="' + checked.id + '"]')
             || (variantRoot && variantRoot.querySelector('label[for="' + checked.id + '"]'));
      }
      if (label) label.setAttribute('data-vavele-explicit-active', 'true');
    }

    function confirmGate() {
      S.gateConfirmed = true;
      clearNeutralState();
      setExplicitActiveLabel();
    }

    /* ── RENDER ─────────────────────────────────────────────── */

    function buildAddLabel() {
      var price = getDisplayPrice(variantRoot);
      if (price) lastKnownPrice = price;           /* update cache on every valid read */
      var p = price || lastKnownPrice;             /* fall back to cache during transient DOM update */
      return p ? addLabel + ' · ' + p : addLabel;
    }

    function render() {
      if (S.isUnavailable) {
        cta.dataset.state = 'unavailable';
        cta.setAttribute('disabled', 'disabled');
        textEl.textContent = addLabel;
        cta.setAttribute('aria-label', addLabel);
        return;
      }

      if (S.isSubmitting) {
        cta.dataset.state = 'submitting';
        cta.setAttribute('disabled', 'disabled');
        textEl.textContent = submittingLabel;
        cta.setAttribute('aria-label', submittingLabel);
        return;
      }

      cta.removeAttribute('disabled');

      if (gateType !== 'none' && !S.gateConfirmed) {
        cta.dataset.state = 'confirm';
        textEl.textContent = gateLabel;
        cta.setAttribute('aria-label', gateLabel);
        return;
      }

      var label = buildAddLabel();
      cta.dataset.state = 'add';
      textEl.textContent = label;
      cta.setAttribute('aria-label', label);
    }

    /* ── AVAILABILITY SYNC ──────────────────────────────────── */

    function syncUnavailable() {
      S.isUnavailable = nativeBtn.disabled
                     || nativeBtn.getAttribute('aria-disabled') === 'true';
    }

    /* ── GATE MISS FEEDBACK ─────────────────────────────────── */

    function scrollToGate() {
      var target = getGateFieldset() || variantRoot;
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target.classList.add('vavele-size-highlight');
      setTimeout(function () { target.classList.remove('vavele-size-highlight'); }, 1300);
    }

    function triggerShake() {
      cta.classList.remove('vavele-inflow-atc--shake');
      void cta.offsetWidth; /* force reflow to restart animation */
      cta.classList.add('vavele-inflow-atc--shake');
      cta.addEventListener('animationend', function onShakeEnd() {
        cta.classList.remove('vavele-inflow-atc--shake');
        cta.removeEventListener('animationend', onShakeEnd);
      });
    }

    /* ── GATE GROUP HIGHLIGHT ────────────────────────────────────
       Adds vavele-gate-highlight to the gate fieldset for 650 ms.
       Uses outline (not box-shadow — overridden by fieldset reset rule).
       Restarts cleanly on repeated taps via clearTimeout + reflow.
       Does NOT touch S, gateConfirmed, neutral, or explicit attrs.
    ─────────────────────────────────────────────────────────── */
    function highlightGateGroup() {
      var gf = getGateFieldset();
      if (!gf) return;
      clearTimeout(highlightTimer);
      gf.classList.remove('vavele-gate-highlight');
      void gf.offsetWidth; /* restart CSS animation on repeated taps */
      gf.classList.add('vavele-gate-highlight');
      highlightTimer = setTimeout(function () {
        gf.classList.remove('vavele-gate-highlight');
      }, 700);
    }

    /* ── SUBMIT ─────────────────────────────────────────────── */
    /* rAF + 50ms pattern from sticky v5. Blur guard for iOS keyboard dismiss.
       No /cart/add.js. No drawer parsing. nativeBtn.click() only. */

    function doNativeClick() {
      requestAnimationFrame(function () {
        setTimeout(function () {
          nativeBtn.click();
          submitFailTimer = setTimeout(function () {
            if (!isDrawerOpen()) {
              S.isSubmitting = false;
              render();
            }
          }, 3000);
        }, 50);
      });
    }

    function handleAdd() {
      if (S.isSubmitting) return;
      if (nativeBtn.disabled || nativeBtn.getAttribute('aria-disabled') === 'true') return;

      S.isSubmitting = true;
      clearTimeout(submitFailTimer);
      render(); /* immediately show DODAWANIE… */

      if (engInputEl && document.activeElement === engInputEl) {
        engInputEl.blur();
        setTimeout(doNativeClick, 320); /* iOS keyboard dismiss safety */
      } else {
        doNativeClick();
      }
    }

    /* ── CTA CLICK ──────────────────────────────────────────── */

    cta.addEventListener('click', function () {
      if (cta.dataset.state === 'confirm') {
        triggerShake();
        scrollToGate();
        highlightGateGroup();
        return;
      }
      if (cta.dataset.state === 'add') {
        handleAdd();
      }
    });

    /* ── VARIANT ROOT LISTENERS (click + change, scoped) ─────── */
    /*
      Both delegated on #variant-selects-{sectionId} — the stable custom element.
      TOP_OPTION_GROUP resolves only top-level containers (modifier classes).
      click: re-tap of already-checked default radio fires click NOT change —
             same reason sticky v5 uses click (line 517).
      change: keyboard nav + dropdown selects.
      Gate detection uses getGateFieldset() identity comparison — reliable,
      no text sniffing in the hot path.
    */
    if (variantRoot) {
      variantRoot.addEventListener('click', function (e) {
        if (gateType === 'none') return;

        var optionGroup = e.target.closest(TOP_OPTION_GROUP);
        if (!optionGroup || !variantRoot.contains(optionGroup)) return;

        if (optionGroup === getGateFieldset()) {
          /* Gate option tapped — confirm on first explicit tap */
          if (!S.gateConfirmed) {
            confirmGate();
            render();
          }
          /* Debounced price refresh — Be Yours async price settle */
          clearTimeout(priceSettleTimer);
          priceSettleTimer = setTimeout(render, 150);
        } else if (!S.gateConfirmed) {
          /* Non-gate option tapped before gate confirmed: keep gate active */
          applyNeutralState();
          render();
        }
      });

      variantRoot.addEventListener('change', function (e) {
        /* Only inputs that represent a real option change */
        var isOptionInput = e.target.classList.contains('button-input__input')
                         || e.target.type === 'radio'
                         || e.target.tagName === 'SELECT';
        if (!isOptionInput) return;

        if (gateType !== 'none') {
          var optionGroup = e.target.closest(TOP_OPTION_GROUP);
          if (optionGroup && variantRoot.contains(optionGroup)) {
            if (optionGroup === getGateFieldset()) {
              if (!S.gateConfirmed) confirmGate();
            } else if (!S.gateConfirmed) {
              applyNeutralState();
            }
          }
        }

        syncUnavailable();
        render();
        clearTimeout(priceSettleTimer);
        priceSettleTimer = setTimeout(render, 150);
      });
    }

    /* ── DRAWER BODY OBSERVER ───────────────────────────────── */
    /* Release submit lock when drawer opens (add succeeded or user opened cart).
       CTA is always visible (in-flow) — no show/hide needed here. */
    new MutationObserver(function () {
      if (isDrawerOpen() && S.isSubmitting) {
        S.isSubmitting = false;
        clearTimeout(submitFailTimer);
        render();
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    /* ── NATIVE BUTTON AVAILABILITY OBSERVER ───────────────── */
    /* Be Yours toggles nativeBtn.disabled on variant availability change. */
    new MutationObserver(function () {
      syncUnavailable();
      render();
    }).observe(nativeBtn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });

    /* ── VARIANT ROOT RE-RENDER OBSERVER ────────────────────── */
    /* Re-applies neutralization when Be Yours replaces variantRoot inner HTML
       on async section fetch (variant URL change). Scoped to variantRoot only. */
    if (variantRoot) {
      var reRenderTimer = null;
      new MutationObserver(function () {
        clearTimeout(reRenderTimer);
        reRenderTimer = setTimeout(function () {
          syncUnavailable();
          if (!S.gateConfirmed) {
            applyNeutralState();
          } else {
            setExplicitActiveLabel();
          }
          render();
        }, 50);
      }).observe(variantRoot, { childList: true, subtree: true });
    }

    /* ── INITIAL ────────────────────────────────────────────── */

    syncUnavailable();
    if (gateType !== 'none') {
      applyNeutralState();
    }
    render();
  }

  /* ── INIT ENTRY POINT ─────────────────────────────────────── */
  /* data-vavele-inflow-bound attribute guards idempotency.
     Inspectable in DevTools; survives if Be Yours replaces the CTA element
     (new element won't have the attribute, so it will be re-initialized). */

  function initInflowCta() {
    document.querySelectorAll('[data-vavele-inflow-atc]:not([data-vavele-inflow-bound])').forEach(function (cta) {
      cta.setAttribute('data-vavele-inflow-bound', 'true');
      try {
        initCtaInstance(cta);
      } catch (_) {
        /* Fail safe — native form flow is never compromised by controller errors */
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInflowCta);
  } else {
    initInflowCta();
  }

  /* Re-bind after Theme Editor section re-render */
  document.addEventListener('shopify:section:load', initInflowCta);

})();